var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M531.5 926.5c-9.8 0-17.9-8.1-17.9-17.9V701.1c0-9.8 8.1-17.9 17.9-17.9 9.8 0 17.9 8.1 17.9 17.9v207.5c0 9.8-8 17.9-17.9 17.9z",
    fill: "#E2E2E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M524.7 919.9c-6.1 0-11.1-5-11.1-11.1V699.6c0-6.1 5-11.1 11.1-11.1s11.1 5 11.1 11.1v209.1c0.1 6.2-4.9 11.2-11.1 11.2z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M692.7 657c163.8-100.8 214.8-315.3 113.9-479.1l-593 365.2C314.4 706.8 528.9 757.9 692.7 657zM669.6 959.8c-9.9-44.8-66-79-133.7-79s-123.7 34.3-133.7 79h267.4z",
    fill: "#E2E2E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M557 881.9c-6.9-0.7-13.9-1.1-21.1-1.1-67.7 0-123.7 34.3-133.7 79h42.1c9-40 54.8-71.6 112.7-77.9z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.5 564.6l-2-3.3c-1.6-2.6-0.8-6.1 1.9-7.7l655.6-402c2.6-1.6 6.1-0.8 7.7 1.9l2 3.3c1.6 2.6 0.8 6.1-1.9 7.7l-655.6 402c-2.6 1.6-6.1 0.7-7.7-1.9z",
    fill: "#BCBCBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M526.1 201.8h47.1c3.5 0 6.3-2.8 6.3-6.3v-2.1c0-3.5-2.8-6.3-6.3-6.3h-47.1c-3.5 0-6.3 2.8-6.3 6.3v2.1c0 3.5 2.8 6.3 6.3 6.3zM509.7 230.3h47.1c3.5 0 6.3-2.8 6.3-6.3v-2.1c0-3.5-2.8-6.3-6.3-6.3h-47.1c-3.5 0-6.3 2.8-6.3 6.3v2.1c0 3.4 2.8 6.3 6.3 6.3z",
    fill: "#E0EDF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M551.4 210.3v-2.1c0-3.5 2.8-6.3 6.3-6.3h8.8c-0.8-0.4-1.7-0.6-2.7-0.6h-25.7c2.6 0.8 4.5 3.2 4.5 6v2.1c0 3.5-2.8 6.3-6.3 6.3h-21.4c0.6 0.2 1.2 0.3 1.8 0.3h38.2c-2-1-3.5-3.2-3.5-5.7z",
    fill: "#E0EDF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M513.6 364.3m-300.1 0a300.1 300.1 0 1 0 600.2 0 300.1 300.1 0 1 0-600.2 0Z",
    fill: "#99CEE3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M353.1 364.3m-76.6 0a76.6 76.6 0 1 0 153.2 0 76.6 76.6 0 1 0-153.2 0Z",
    fill: "#EBB838"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M513.6 664.4c165.7 0 300.1-134.3 300.1-300.1H213.6c0 165.7 134.3 300.1 300 300.1z",
    fill: "#27A0C8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M526.1 201.8h47.1c3.5 0 6.3-2.8 6.3-6.3v-2.1c0-3.5-2.8-6.3-6.3-6.3h-47.1c-3.5 0-6.3 2.8-6.3 6.3v2.1c0 3.5 2.8 6.3 6.3 6.3zM509.7 230.3h47.1c3.5 0 6.3-2.8 6.3-6.3v-2.1c0-3.5-2.8-6.3-6.3-6.3h-47.1c-3.5 0-6.3 2.8-6.3 6.3v2.1c0 3.4 2.8 6.3 6.3 6.3zM563.8 181.9h-2.1c-3.5 0-6.3-2.8-6.3-6.3v-2.1c0-3.5 2.8-6.3 6.3-6.3h2.1c3.5 0 6.3 2.8 6.3 6.3v2.1c0 3.4-2.9 6.3-6.3 6.3zM582.5 231.7h-7.6c-3.5 0-6.3-2.8-6.3-6.3v-2.1c0-3.5 2.8-6.3 6.3-6.3h7.6c3.5 0 6.3 2.8 6.3 6.3v2.1c0 3.5-2.8 6.3-6.3 6.3zM449.5 194.5h-7.6c-3.5 0-6.3-2.8-6.3-6.3v-2.1c0-3.5 2.8-6.3 6.3-6.3h7.6c3.5 0 6.3 2.8 6.3 6.3v2.1c0 3.4-2.8 6.3-6.3 6.3z",
    fill: "#E0EDF0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M644.7 303.7h33.4c2.5 0 4.5-2 4.5-4.5v-1.5c0-2.5-2-4.5-4.5-4.5h-33.4c-2.5 0-4.5 2-4.5 4.5v1.5c0 2.5 2 4.5 4.5 4.5zM633 323.9h33.4c2.5 0 4.5-2 4.5-4.5v-1.5c0-2.5-2-4.5-4.5-4.5H633c-2.5 0-4.5 2-4.5 4.5v1.5c0.1 2.5 2.1 4.5 4.5 4.5z",
    fill: "#E0EDF0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M512.9 666.4c85.1 0 162-35.5 216.6-92.4-30-90.9-115.6-156.5-216.6-156.5S326.3 483.1 296.3 574c54.6 56.9 131.5 92.4 216.6 92.4z",
    fill: "#FFC627"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M577 508.2H450.2c-11.4 0-20.6 9.2-20.6 20.6v123.6c26.6 7.8 54.8 11.9 84 11.9 29.2 0 57.3-4.2 84-11.9V528.8c0-11.3-9.2-20.6-20.6-20.6z",
    fill: "#F25421"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M503.2 130.6c3.1 4.4 8 7.2 13.4 7.6 5.9 0.4 11.7 1 17.6 1.8C664 158.3 754.7 278.7 736.4 408.5c-1.7 12.4-4.4 24.4-7.9 36-1.6 5.2-0.7 10.7 2.4 15.2 8.4 12.1 27.1 9.2 31.4-4.9 4-13.3 7.1-27.1 9.1-41.3 21-149-83.2-287.3-232.2-308.3-6.8-1-13.6-1.7-20.4-2.1-14.7-1.2-23.9 15.4-15.6 27.5z",
    fill: "#FFFFFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M723.7 512.2m-19.2 0a19.2 19.2 0 1 0 38.4 0 19.2 19.2 0 1 0-38.4 0Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.48bbde800ed30bf1f639cdbeb29521e4.svg";
export { ForwardRef as ReactComponent };